export default __webpack_public_path__ + "assets/raindrops.a164ac4f.svg";